import cx from "classnames"

interface FieldErrorMessageProps {
  children: React.ReactNode
  className?: string
  id: string
}

export function FieldErrorMessage({
  children,
  className,
  id,
  ...props
}: FieldErrorMessageProps) {
  return (
    <p
      id={id}
      role="alert"
      className={cx("c-ruby mb-0 mt-4p fs-4", className)}
      {...props}
    >
      {children}
    </p>
  )
}
